// Dependencies
import React, { createClass, PropTypes } from 'react';
import Icon from '../tc-ui/icon';
import { findDOMNode } from 'react-dom';


// Components

const ConnectionsTag = createClass({

  propTypes: {
    tag: PropTypes.string,
    addOrRemoveTag: PropTypes.func,
    isTagModal: PropTypes.bool,
    className: PropTypes.string,
  },

  componentWillEnter(cb) {
    const style = findDOMNode(this).style;
    style.opacity = '0';
    style.color = 'green';
    setTimeout(cb, 50);
  },

  componentDidEnter() {
    const style = findDOMNode(this).style;
    style.transition = 'all .3s ease-in';
    style.color = 'rgba(0, 0, 0, 0.870588)';
    style.opacity = '1';
  },

  componentWillLeave(cb) {
    const style = findDOMNode(this).style;
    style.transition = 'all .3s ease-in';
    style.opacity = '0';
    setTimeout(cb, 300);
  },

  sendTagToParent() {
    this.props.addOrRemoveTag(this.props.tag);
  },

  removeTag() {
    this.props.addOrRemoveTag(this.props.tag, 'remove');
  },

  render() {
    const { clickEvent, className, icon } = (() => {
      if (this.props.isTagModal) {
        return {
          className: 'individual-tag',
          icon: <Icon className="tc-icon-close" onClick={this.removeTag} />,
        };
      }
      return {
        clickEvent: this.sendTagToParent,
        className: this.props.className,
      };
    })();


    return (
      <div className={className} onClick={clickEvent}>
        {this.props.tag}
        {icon}
      </div>
    );
  },
});

export default ConnectionsTag;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tag.jsx